
define('modules/application/wizard/classes/inserters',[
    "app",

    // Libs
    "backbone",

    // Classes
    "./genericCollectionSection"

  ],

  function(app, Backbone, genericCollectionSection) {

    var eventsToBind = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
    var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {

      View: genericCollectionSection.genericCollectionItem.View.extend({
        tagName: "li",
        className: "inserter",
        template: "application/wizard/sections/genericCollectionSection/inserter",
        events: _.extend(eventsToBind, {
          "change .type": "typeChangedEventHandler",
          "keyup input[name='description']": "descriptionChangedEventHandler"
        }),

        initialize: function() {
          this.model.unbind("render:requested", this.render);
          this.model.bind("render:requested", this.render, this);

          this.model.unbind("change:number", this.render);
          this.model.bind("change:number", this.render, this);
        },
        typeChangedEventHandler: function(e) {
          var type = e.currentTarget.value;

          //Update the model
          this.model.set("type", type);
        },
        descriptionChangedEventHandler: function(e) {
          this.model.set("description", e.currentTarget.value);
        }
      }),

      Model: genericCollectionSection.genericCollectionItem.Model.extend({
        defaults: {
          number: -1,
          selected: false,
          description: ""
        },

        initialize: function() {
          var that = this;
          genericCollectionSection.genericCollectionItem.Model.prototype.initialize.apply(this);

          //Bind on main control unit selection
          window.BticinoS4B.eventAggregator.bind('mainControlUnit:chosen', function(mainControlUnitId) {
            that.fetchPackages(mainControlUnitId);
          });

          this.unbind("change:type", this.typeChangedEventHandler);
          this.bind("change:type", this.typeChangedEventHandler, this);

           if (!this.get("type")) {
            if (BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel")) {
              this.fetchPackages(BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel"));
              this.set("type", this.get("fetchedPackages")[0].packageClassId);
            }
          } else {
            if (BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel")) {
              this.fetchPackages(BticinoS4B.Instances.Models.ApplicationModel.get("mainControlUnitModel"));
              this.typeChangedEventHandler();
            }
          }
        },

        typeChangedEventHandler: function() {
          var type = this.get("type"),
            that = this;

          //Merging with wizard package attributes
          var wizardAttributes = _.filter(that.get("fetchedPackages"), function(pack) {
            return pack.packageClassId === type;
          });

          if (wizardAttributes.length === 1)
            wizardAttributes = wizardAttributes[0];
          _.extend(this.attributes, wizardAttributes);

          //Merging with item's attributes
          if ((type) && (type !== "")) {
            BticinoS4B.Instances.Models.ApplicationModel.getProducts(type, function(data) {
              data.products = BticinoS4B.Instances.Models.ApplicationModel.filterProductsByCatalogAndWizardChoices(data.products);
              var products = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              });
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });
              products = products[0];
              _.extend(that.attributes, products);

              that.set("secondaryProducts", secondaryProducts);
            });
          } else {
            this.resetValues();
          }

          that.trigger("render:requested");
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
        },

        resetValues: function() {
          this.set("catalogId", undefined);
          this.set("description", undefined);
          this.set("image", undefined);
          this.set("links", undefined);
          this.set("mnemonic", undefined);
          this.set("optionalPackages", undefined);
          this.set("packageActuator", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
          this.set("packageInDepth", undefined);
          this.set("packageLoad", undefined);
          this.set("price", undefined);
          this.set("productCode", undefined);
          this.set("productDescription", undefined);
          this.set("productInDepth", undefined);
          this.set("productLabel", undefined);
          this.set("specialVars", undefined);
          this.set("wizardChoiceDescription", undefined);
          this.set("wizardChoiceLabel", undefined);
          this.set("packageClassDescription", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
        },

        fetchPackages: function(mainControlUnit) {
          var mcuPackageClassId;

          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId")) {
            var that = this;
            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice(406, function(data) {
              var fetchedPackages = data.packages,
                fetchedPackagesLength = fetchedPackages.length;
              var filteredPackages;

              //Adding compatibilities to the retrieved packages
              for (i = 0; i < fetchedPackagesLength; i++) {
                if (typeof fetchedPackages[i].specialVars !== "object")
                  fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);
                fetchedPackages[i].type = fetchedPackages[i].specialVars.type;
              }

              that.set("fetchedPackages", fetchedPackages);

              //Filter uncompatible packages
              filteredPackages = fetchedPackages;

              filteredPackages = _.filter(fetchedPackages, function(currentPackage) {
                if (_.indexOf(currentPackage.specialVars.mcuCompatibilityWithThisValues, mainControlUnit.get("specialVars").maxZoneNumber) !== -1)
                  return true;
                else
                  return false;
              });
              that.set("fetchedPackages", filteredPackages);
            });
          }
        },

        deliverCurrent: function() {
          if (this.get("specialVars")) {
            var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
            var currentConsumption = this.get("specialVars").currentConsumption;

            if (currentConsumption < 0)
              consumptionIndicatorModel.addSupplyCurrent(currentConsumption);
            else
              consumptionIndicatorModel.addCurrentConsumption(currentConsumption);
          }
        }
      })

    });

    var inserters = _.extend({}, genericCollectionSection, {

      Views: {
        titleBar: genericCollectionSection.Views.titleBar.extend(),
        content: genericCollectionSection.Views.content.extend({
          template: "application/wizard/sections/genericCollectionSection/collectionWithInfo",
          events: _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
            "click .toggleInfoButton": "toggleInfos"
          }),

          toggleInfos: function(e) {
            return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
          },

          addItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.addItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          duplicateItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.duplicateSelectedItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              this.insertView(".elements", viewToAdd);
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          removeItemButtonClickedEventHandler: function() {
            var elementToRemove = this.model.removeSelectedItem();
            var viewToRemove = this.getView(function(view) {
              return (elementToRemove === view.model);
            });
            if (viewToRemove) {
              viewToRemove.$el.remove();
              this.model.sortItems();
            }
          },

          beforeRender: function() {
            var collection = this.model.get("collection"),
              collectionLength = collection.models.length;
            var collectionItemView = genericCollectionItem.View;
            var i = 0;

            for (i = 0; i < collectionLength; i++)
              this.insertView(".elements", new collectionItemView({
                model: collection.models[i]
              }));
          },

          afterRender: function() {
            if (this.model.get("collection").length === 0)
              this.$el.append("<h4 class='alert'>" + $.i18n._("IDS_WAI1001_9018") + "</h4>");
            window.customizeFormElements.call();
          }
        })
      },

      Model: genericCollectionSection.Model.extend({
        defaults: _.extend({
          name: "IDS_WAI8_6",
          collectionEventAggregator: _.extend({}, Backbone.Events),
          infoQuote: "IDS_WGENTT_000019",
          valid       : true,
          maxItem: 7
        }, genericCollectionSection.Model.prototype.defaults),

        initialize: function() {
          genericCollectionSection.Model.prototype.initialize.apply(this);
          var collectionItemModel = genericCollectionItem.Model;
          var collectionModel = Backbone.Collection.extend({
            model: collectionItemModel
          });
          var collection;
          var oldCollection, i = 0;


          this.get("collectionEventAggregator").unbind("render:requested", this.renderRequestedEventHandler);
          this.get("collectionEventAggregator").bind("render:requested", this.renderRequestedEventHandler, this);

          //Perimetral protection zone events
          this.get("zoneEventAggregator").unbind("perimetralProtection:changed", this.perimetralProtectionChangedEventHandler);
          this.get("zoneEventAggregator").bind("perimetralProtection:changed", this.perimetralProtectionChangedEventHandler, this);

          //Radio sensors zone events
          this.get("zoneEventAggregator").unbind("radioSensors:changed", this.radioSensorsChangedEventHandler);
          this.get("zoneEventAggregator").bind("radioSensors:changed", this.radioSensorsChangedEventHandler, this);

          //Lengths communication events
          this.get("zoneEventAggregator").unbind("communicate:lengths", this.lengthsCommunicationRequested);
          this.get("zoneEventAggregator").bind("communicate:lengths", this.lengthsCommunicationRequested, this);

          if (this.get("collection")) {
            oldCollection = this.get("collection");

            if (oldCollection.models)
              oldCollection = oldCollection.models;
          }

          this.set("collection", new collectionModel());
          collection = this.get("collection");

          if (oldCollection) {
            for (i = 0; i < oldCollection.length; i++) {
              if (!oldCollection[i].attributes)
                this.addItem(_.extend({
                  collectionEventAggregator: this.get("collectionEventAggregator")
                }, oldCollection[i]));
              else
                collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
            }
          }

          if (collection.length < this.get("minItem"))
            this.addItem();

          this.sortItems();

          this.get("collectionEventAggregator").bind("selectedItem:changed", this.selectedItemChangedEventHandler, this);
          this.set("maxItem", 7);

          //Bind on materials overview model delivery request
          window.BticinoS4B.eventAggregator.unbind("modelDeliver:request", this.deliverModel);
          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);

          window.BticinoS4B.eventAggregator.unbind("load:Project", this.loadProject);
          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          window.BticinoS4B.eventAggregator.unbind("currentDeliver:requested", this.deliverCurrent);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);
        },

        isPossibleToAdd: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          return (collectionLength + 1) <= this.get("maxItem");
        },

        addItem: function(itemModel) {
          var defaultItem;

          if (this.isPossibleToAdd()) {
            var collectionItemModel = genericCollectionItem.Model;

            if (itemModel)
              defaultItem = new collectionItemModel(itemModel);
            else
              defaultItem = new collectionItemModel({
                number: this.getNewNumber(),
                collectionEventAggregator: this.get("collectionEventAggregator")
              });

            var itemsToAdd = [];
            itemsToAdd.push(defaultItem);
            genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd);
            defaultItem.set("selected", true);
            this.trigger("updateViews", this.get("collection").length);
            
            //Trigger event for zone validation
            this.sortItems();
            this.trigger("item:added");
            window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

            return defaultItem;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        duplicateItem: function(modelToDuplicate) {
          var collectionItemModel = genericCollectionItem.Model;
          var itemNumber = this.getNewNumber();
          var collection = this.get("collection"),
            collectionLength = collection.length;

          var perimetralProtectionLength = this.get("perimetralProtectionLength") ? this.get("perimetralProtectionLength") : 0;
          var radioSensorsLength = this.get("radioSensorsLength") ? this.get("radioSensorsLength") : 0;

          if (this.isPossibleToAdd()) {
            if (modelToDuplicate) {
              modelToDuplicate = new collectionItemModel(modelToDuplicate.attributes);
              if (modelToDuplicate) {
                if (modelToDuplicate.get("partOfKit") !== undefined) {
                  modelToDuplicate.set("partOfKit", undefined);
                }

                modelToDuplicate.set("number", itemNumber);
                this.get("collection").add(modelToDuplicate);
                this.trigger("updateViews", this.get("collection").length);

                //Trigger event for zone validation
                this.sortItems();
                this.trigger("item:added");
                this.trigger("render:requested");

                window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
                return modelToDuplicate;
              } else
                return false;
            } else
              return false;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        sortItems: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0;

          for (i = 0; i < collectionLength; i++) {
            collection.models[i].set("number", (i + 1));
            if (i === (collectionLength - 1))
              collection.models[i].set("selected", true);
          }
        },

        removeItem: function(modelToRemove, _silent) {
          var silent = false;

          if (_silent)
            silent = _silent;

          if (!modelToRemove.get("partOfKit") || silent) {
            if (this.deleteItem(modelToRemove, silent)) {
              this.trigger("updateViews", this.get("collection").length);

              this.sortItems();

              //Trigger event for zone validation
              this.trigger("item:removed");
              this.trigger("render:requested");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

              return modelToRemove;
            }
          } else{
            alert($.i18n._('IDS_W1_9191'));
            return false;
          }
        },

        deliverModel: function() {
          BticinoS4B.solution.intrusionDetection.inserters = this;
          BticinoS4B.Instances.Models.ApplicationModel.set("inserters", this);
        },

        loadProject: function(model) {
          var i = 0;
          var inserterModels=null,
              inserterModelsLength=0;
          if(model.inserters){
            inserterModels = model.inserters.inserters;
            inserterModelsLength = inserterModels ? inserterModels.length : 0;
          }
          var collectionItemModel = genericCollectionItem.Model,
            defaultItem;
          var itemsToAdd = [];

            if(inserterModelsLength)
              for (i = 0; i < inserterModelsLength; i++) {
                defaultItem = new collectionItemModel(_.extend({
                  collectionEventAggregator: this.get("collectionEventAggregator")
                }, inserterModels[i]));
                itemsToAdd.push(defaultItem);
                genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd);
              }

          if (defaultItem)
            defaultItem.set("selected", true);

          if (itemsToAdd.length > 0)
            genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd);
    
          this.trigger("render:requested");
          this.trigger("updateViews", this.get("collection").length);
        },

        isThereAnIncompatibleInserterAtLeast: function(maxZoneNumber) {
          var collection = this.get("collection").models,
            collectionLength = collection.length,
            i = 0;

          for (i = 0; i < collectionLength; i++)
            if (_.indexOf(collection[i].get("specialVars").mcuCompatibilityWithThisValues, maxZoneNumber) === -1)
              return true;

          return false;
        },

        removeIncompatibleInserters: function(maxZoneNumber) {
          var collection = this.get("collection").models,
            collectionLength = collection.length,
            i = 0;

          for (i = collectionLength - 1; i >= 0; i--)
            if (_.indexOf(collection[i].get("specialVars").mcuCompatibilityWithThisValues, maxZoneNumber) === -1)
              this.deleteItem(collection[i], true);

          this.sortItems();
          return false;
        },

        deliverCurrent: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0;

          for (i = 0; i < collectionLength; i++)
            collection.models[i].deliverCurrent();
        }

      }),
      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return inserters;

  });